// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"b7e14b7f","368":"f39823d8","488":"c79d117f","687":"2cb110bb","978":"8e571cd9"}[chunkId] + ".chunk.js";
};